import { toOnlineClassesSlugID } from "@outschool/routes";
import { ErrorMessage } from "@outschool/ui-components-shared";
import { Loading } from "@outschool/ui-legacy-component-library";
import React from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";

import * as Env from "../../../shared/Env";
import { useCuratedPageSlugsQuery } from "../../hooks/useCuratedCategoryPageQuery";
import PaidCategoryLandingPage from "../../routes/PaidCategoryLandingPage";
import CategoryPage from "./basic/CategoryPage";
import SchoolPage from "./basic/SchoolPage";
import CuratedCategoryPage from "./curated/CuratedCategoryPage";
import { useIsPaidLandingPage } from "./hooks/useIsPaidLandingPage";

export default function CategoryPageMultiplex() {
  const categorySlug = toOnlineClassesSlugID(
    // @ts-ignore TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    useParams<{ themeOrQuery?: string }>()?.themeOrQuery,
  );
  const { loading, data, error } = useCuratedPageSlugsQuery();
  const isPaidLandingPage = useIsPaidLandingPage();

  const location = useLocation();
  if (location.pathname.match(/\/schools\/.*/)) {
    return <SchoolPage />;
  }

  const curatedSlugs = data?.curatedPages?.map(el => el?.slug) ?? [];

  if (isPaidLandingPage) {
    return <PaidCategoryLandingPage />;
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <ErrorMessage value={error} showStatusPageLink={Env.IS_READ_ONLY_MODE} />
    );
  }

  if (categorySlug && curatedSlugs.includes(categorySlug)) {
    return <CuratedCategoryPage categorySlug={categorySlug} />;
  } else {
    return <CategoryPage />;
  }
}
